var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfizLogoEventsPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1814",
    "data-name": "Grupo 1814",
    xmlns: "http://www.w3.org/2000/svg",
    width: 165.237,
    height: 45,
    viewBox: "0 0 165.237 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1743",
    "data-name": "Grupo 1743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422",
    "data-name": "Caminho 422",
    d: "M46.848,19.422a.307.307,0,0,0,.314-.3v-2.1a.307.307,0,0,0-.314-.3h-5.78a1.45,1.45,0,0,0-1,.4l-3.911,3.732h-8.4L37.89,11.178a.291.291,0,0,0,0-.424l-2-1.908a.325.325,0,0,0-.444,0L25.309,18.52V10.5L29.22,6.769a1.319,1.319,0,0,0,.414-.954V.3A.307.307,0,0,0,29.32,0h-2.2a.307.307,0,0,0-.314.3V5.256L23.581,8.334,20.356,5.256V.3a.307.307,0,0,0-.314-.3h-2.2a.307.307,0,0,0-.314.3V5.815a1.319,1.319,0,0,0,.414.954L21.853,10.5V18.52L11.715,8.847a.325.325,0,0,0-.444,0l-2,1.908a.29.29,0,0,0,0,.424l10.138,9.673H11L7.094,17.12a1.45,1.45,0,0,0-1-.4H.314a.307.307,0,0,0-.314.3v2.1a.307.307,0,0,0,.314.3H5.509L8.734,22.5,5.509,25.578H.314a.307.307,0,0,0-.314.3v2.1a.307.307,0,0,0,.314.3h5.78a1.45,1.45,0,0,0,1-.4L11,24.149h8.4L9.272,33.822a.29.29,0,0,0,0,.424l2,1.908a.325.325,0,0,0,.444,0L21.853,26.48V34.5l-3.911,3.731a1.319,1.319,0,0,0-.414.954V44.7a.307.307,0,0,0,.314.3h2.2a.307.307,0,0,0,.314-.3V39.744l3.225-3.078,3.225,3.078V44.7a.307.307,0,0,0,.314.3h2.2a.307.307,0,0,0,.314-.3V39.185a1.318,1.318,0,0,0-.414-.954L25.309,34.5V26.48l10.36,9.885,2.444-2.332-10.36-9.885h8.4l3.911,3.732a1.449,1.449,0,0,0,1,.4h5.78a.307.307,0,0,0,.314-.3v-2.1a.307.307,0,0,0-.314-.3H41.653L38.428,22.5l3.225-3.078ZM23.581,24.764,21.208,22.5l2.373-2.264L25.954,22.5Z",
    fill: "#a6ff00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1744",
    "data-name": "Grupo 1744",
    transform: "translate(49.519 8.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_423",
    "data-name": "Caminho 423",
    d: "M351.111,65.825c0,5.287-3.525,8.812-10.77,8.812H328.788v9.791h-3.916V57.013h15.469C347.586,57.013,351.111,60.538,351.111,65.825Zm-4.112,0c0-2.937-2.154-5.091-6.658-5.091H328.788V70.916h11.553C344.845,70.916,347,68.762,347,65.825Z",
    transform: "translate(-324.872 -56.23)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_424",
    "data-name": "Caminho 424",
    d: "M488.98,90.229H492.9v3.446h.2a7.99,7.99,0,0,1,6.462-3.446h2.193V93.95h-2.193c-5.483,0-6.658,3.211-6.658,3.211v14.608H488.98Z",
    transform: "translate(-459.956 -83.571)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_425",
    "data-name": "Caminho 425",
    d: "M563.781,99.176c0-6.266,4.9-11.161,13.119-11.161s13.119,4.9,13.119,11.161-4.9,11.161-13.119,11.161S563.781,105.442,563.781,99.176Zm22.323,0c0-4.7-3.133-7.832-9.2-7.832s-9.2,3.133-9.2,7.832,3.133,7.833,9.2,7.833S586.1,103.876,586.1,99.176Z",
    transform: "translate(-521.528 -81.749)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_426",
    "data-name": "Caminho 426",
    d: "M714.713,59.243h4.308c0-4.112,2.546-6.658,6.658-6.658h11.553v3.329H726.07c-1.958,0-3.133,1.175-3.133,3.329h14.49V80.782h-3.916V62.571H722.937V80.782h-3.916V62.571h-4.308Z",
    transform: "translate(-645.767 -52.585)",
    fill: "#a6ff00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_427",
    "data-name": "Caminho 427",
    d: "M857.384,108.44l15.665-14.49v-.2H857.58V90.229h20.756v3.329l-15.665,14.49v.2h16.253v3.525H857.384Z",
    transform: "translate(-763.205 -83.571)",
    fill: "#a6ff00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfizLogoEventsPage);
export default __webpack_public_path__ + "static/media/profizLogoEventsPage.2368eb6e45d957a656d75113b0a73982.svg";
export { ForwardRef as ReactComponent };